import React from 'react'
import heroimg from '../../Assets/homeimgs/heroimg.png'

const HeroSection = () => {
    return (
        <React.Fragment>
            <div
                className="h-[60vh] md:h-[75vh] lg:h-[85vh] flex items-center justify-center"
                style={{
                    backgroundImage: `url(${heroimg})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right",
                }}
            >
                <div className="text-center text-white max-w-[90%] sm:max-w-[80%] md:max-w-[70%] space-y-4 md:space-y-6 lg:space-y-10 px-4">
                    <h1
                        style={{ fontFamily: "Poppins, sans-serif" }}
                        className="text-xl sm:text-2xl md:text-4xl lg:text-6xl font-normal space-y-4"
                    >
                       <span> Strong Foundations for Endless</span> <span>Connections</span>
                    </h1>
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl">
                        We built with precision and durability, creating lasting pathways that
                        connect people, places, and opportunities. With a focus on quality and
                        innovation, we ensure every structure stands the test of time, fostering
                        connections for generations to come.
                    </p>
                </div>
            </div>

        </React.Fragment>
    )
}

export default HeroSection